<section class="recruiter-trusted-companies-section">
  <div
    class="recruiter-trusted-companies-container max-w-7xl mx-auto px-6 lg:px-8 py-10 text-center border-b border-slate-200">
    <h2 class="text-4xl font-bold text-slate-900 mb-6">Trusted Companies Section</h2>
    <p class="text-lg text-slate-600 max-w-2xl mx-auto">This is the Trusted Companies section for the recruiter landing
      page. The content will be updated to match the design.</p>
  </div>
</section>